"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _uiComponent = _interopRequireDefault(require("../ui-component"));

var _validator = _interopRequireDefault(require("../component/validator"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Field = /*#__PURE__*/function (_UIComponent) {
  (0, _inherits2.default)(Field, _UIComponent);

  var _super = _createSuper(Field);

  function Field() {
    var _this;

    (0, _classCallCheck2.default)(this, Field);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'Field');
    return _this;
  }

  (0, _createClass2.default)(Field, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(Field.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            // The name is required as it is needed by the form
            name: 'name',
            required: true
          }, {
            name: 'label',
            component: 'TextField',
            label: 'Label',
            docLevel: 'basic'
          }, {
            name: 'value',
            component: 'Field'
          }, {
            name: 'err',
            component: 'Field'
          }, {
            name: 'required',
            component: 'BooleanField',
            label: 'Required',
            docLevel: 'basic'
          }, {
            name: 'fullWidth',
            component: 'BooleanField',
            label: 'Full Width',
            docLevel: 'basic'
          }, {
            name: 'touched',
            component: 'BooleanField'
          }, {
            name: 'validators',
            component: 'Field'
          }, {
            name: 'block',
            component: 'BooleanField',
            label: 'Block',
            docLevel: 'basic'
          }, {
            name: 'disabled',
            component: 'BooleanField',
            label: 'Disabled',
            docLevel: 'basic'
          }, {
            name: 'editable',
            component: 'BooleanField',
            label: 'Editable' // docLevel: 'basic'

          }, {
            name: 'dirty',
            component: 'BooleanField'
          }, {
            name: 'help',
            component: 'TextField',
            label: 'Help'
          }, {
            name: 'in',
            component: 'BooleanField'
          }, {
            name: 'out',
            component: 'BooleanField'
          }, {
            name: 'before',
            component: 'TextField'
          }, {
            name: 'after',
            component: 'TextField'
          }, {
            name: 'showArchived',
            component: 'BooleanField'
          }, {
            name: 'searchString',
            component: 'TextField'
          }, {
            name: 'ignoreErrs',
            component: 'BooleanField'
          }, {
            name: 'forbidSort',
            component: 'BooleanField'
          }, {
            name: 'hideLabel',
            component: 'BooleanField'
          }, {
            name: 'useDisplayValue',
            component: 'BooleanField',
            label: 'Use Display Value',
            docLevel: 'basic'
          }, {
            name: 'autoHideLabel',
            component: 'BooleanField'
          }]
        }
      });

      this._setDefaults(props, {
        editable: true,
        block: true,
        out: true,
        in: true,
        hidden: false,
        required: false,
        fullWidth: false,
        disabled: false,
        autoHideLabel: true
      });
    }
  }, {
    key: "_setValue",
    value: function _setValue(value) {
      this._set('value', value);
    }
  }, {
    key: "_setRequired",
    value: function _setRequired(required) {
      this._set('required', required);
    }
  }, {
    key: "_setDisabled",
    value: function _setDisabled(disabled) {
      this._set('disabled', disabled);
    }
  }, {
    key: "_setEditable",
    value: function _setEditable(editable) {
      this._set('editable', editable);
    }
  }, {
    key: "_setDirty",
    value: function _setDirty(dirty) {
      this._set('dirty', dirty);
    }
  }, {
    key: "setTouched",
    value: function setTouched(touched) {
      this._set('touched', touched);
    }
  }, {
    key: "setFullWidth",
    value: function setFullWidth(fullWidth) {
      this._set('fullWidth', fullWidth);
    }
  }, {
    key: "setUseDisplayValue",
    value: function setUseDisplayValue(useDisplayValue) {
      this._set('useDisplayValue', useDisplayValue);
    }
  }, {
    key: "setHideLabel",
    value: function setHideLabel(hideLabel) {
      this._set('hideLabel', hideLabel);
    }
  }, {
    key: "set",
    value: function set(props) {
      if (props.value !== undefined && props.value !== this.get('value')) {
        this.set({
          dirty: true
        });
      }

      (0, _get2.default)((0, _getPrototypeOf2.default)(Field.prototype), "set", this).call(this, Object.assign({}, props, {
        value: undefined,
        required: undefined,
        disabled: undefined,
        editable: undefined,
        dirty: undefined,
        touched: undefined,
        fullWidth: undefined,
        useDisplayValue: undefined,
        hideLabel: undefined
      }));

      if (props.value !== undefined) {
        this._setValue(props.value);
      }

      if (props.required !== undefined) {
        this._setRequired(props.required);
      }

      if (props.disabled !== undefined) {
        this._setDisabled(props.disabled);
      }

      if (props.editable !== undefined) {
        this._setEditable(props.editable);
      }

      if (props.dirty !== undefined) {
        this._setDirty(props.dirty);
      }

      if (props.touched !== undefined) {
        this.setTouched(props.touched);
      }

      if (props.fullWidth !== undefined) {
        this.setFullWidth(props.fullWidth);
      }

      if (props.useDisplayValue !== undefined) {
        this.setUseDisplayValue(props.useDisplayValue);
      }

      if (props.hideLabel !== undefined) {
        this.setHideLabel(props.hideLabel);
      }
    }
  }, {
    key: "setErr",
    value: function setErr(err) {
      this.set({
        err: err
      });
    }
  }, {
    key: "clearErr",
    value: function clearErr() {
      this.setErr(null);
    }
  }, {
    key: "getErr",
    value: function getErr() {
      return this.get('err');
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.set({
        value: value
      });
    }
  }, {
    key: "clearValue",
    value: function clearValue() {
      this.setValue(null);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.get('value');
    }
  }, {
    key: "isValueBlank",
    value: function isValueBlank(value) {
      return this.constructor.isValueBlank(value);
    }
  }, {
    key: "isBlank",
    value: function isBlank() {
      var value = this.getValue();
      return this.isValueBlank(value);
    }
  }, {
    key: "_toValidatorProps",
    value: function _toValidatorProps() {
      return this;
    } // TODO: also support _validators being function like at form layer?

  }, {
    key: "validate",
    value: function validate() {
      if (!this.get('ignoreErrs')) {
        if (this._required && this.isBlank()) {
          this.setErr('required');
        } else if (!this.isBlank() && this._validators && this._validators.length > 0) {
          var validator = new _validator.default(this._toValidatorProps());
          var errors = validator.validate(this._validators);

          if (errors.length !== 0) {
            this.setErr(errors[0]);
          }
        }
      }
    } // TODO: introduce concept of icons for display values, e.g. edit event in Google Calendar

  }, {
    key: "getDisplayValue",
    value: function getDisplayValue() {
      return this.get('value');
    }
  }, {
    key: "hasErr",
    value: function hasErr() {
      return !!this.get('err');
    }
  }, {
    key: "_validateWithRegExp",
    value: function _validateWithRegExp(regExp, err) {
      if (!this.isBlank()) {
        var value = this.getValue();

        if (!regExp.test(value)) {
          this.setErr(err);
        }
      }
    }
  }, {
    key: "getFirstErr",
    value: function getFirstErr() {
      var err = this.get('err');
      var i = 0;
      var MAX_DEPTH = 2;

      while (Array.isArray(err)) {
        if (i++ === MAX_DEPTH) {
          // We don't expect this much nesting, therefore we will stringify the result to allow the UI
          // to reveal details that will help to identify the root problem
          return JSON.stringify(err);
        } else {
          err = err[0].error;
        }
      }

      return err;
    } // Method used to determine if this component is a field, even if it is wrapped

  }, {
    key: "isField",
    value: function isField() {
      return true;
    }
  }]);
  return Field;
}(_uiComponent.default);

exports.default = Field;

Field.isValueBlank = function (value) {
  return value === null || value === undefined;
};